export const initExpandingColumnElement = () => {
    const cells = document.querySelectorAll('.expandingcolumnelement.features1 .grid-x .cell');
    let expandedCell = null;

    function handleCellInteraction() {
        if (expandedCell === this) return;

        cells.forEach(c => {
            c.classList.remove('medium-4', 'medium-6');
            c.classList.add('medium-3');
        });

        this.classList.remove('medium-3');
        this.classList.add('medium-6');
        expandedCell = this;
    }

    function updateListeners() {
        const isWide = window.matchMedia("(min-width: 1150px)").matches;
        cells.forEach(cell => {
            cell.removeEventListener('click', handleCellInteraction);
            cell.removeEventListener('mouseover', handleCellInteraction);
            if (isWide) {
                cell.addEventListener('click', handleCellInteraction);
                cell.addEventListener('mouseover', handleCellInteraction);
            }
        });
    }

    updateListeners();

    let debounceTimer;
    function debounce(func, delay) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(func, delay);
    }

    window.addEventListener('resize', () => {
        debounce(updateListeners, 100);
    });
};
